import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { type FeatureFlagVariants } from "@src/appV2/FeatureFlags/types";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

import { DEFAULT_MISSED_SHIFTS_CONFIG } from "./types";

export function useMissedShiftsConfig(): FeatureFlagVariants[CbhFeatureFlag.MISSED_SHIFTS_CONFIGURATION] {
  return useCbhFlag(CbhFeatureFlag.MISSED_SHIFTS_CONFIGURATION, {
    defaultValue: DEFAULT_MISSED_SHIFTS_CONFIG,
  });
}
